import { useEffect } from "react";

import { useRouter } from "next/navigation";

import { useAppDispatch, useAppSelector } from "@/providers/store/hooks";
import { setServerError } from "@/providers/store/slices/app/slice";

export const useServerErrorRedirect = () => {
  const serverError = useAppSelector((state) => state.app.serverError);
  const dispatch = useAppDispatch();
  const router = useRouter();
  const errorPageHref = "/internal-error";

  useEffect(() => {
    if (serverError) {
      router.push(errorPageHref);
      dispatch(setServerError(false));
    }
  }, [serverError, router, dispatch]);
};
